import React from 'react';
import { connect } from 'react-redux';

import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import { SSelect } from '@avalara/skylab-sdk/react';

const log = new Logger('INTEGER_SELECTOR', LOG_LEVELS.DEBUG);

function parseMinMaxIntsAndOrder(min, max) {
  const pMin = parseInt(min);
  const pMax = parseInt(max);

  if (!isNaN(pMin) && !isNaN(pMax) && pMin > pMax) {
    return {min: pMax, max: pMin};
  }
  return {min: pMin, max: pMax};
}

export class IntegerSelector extends React.Component {

    selectionHandler(event) {
        log.debug('selectionHandler(): ', event);
        log.debug('selectionHandler(): item.value', event.detail.item.value);
        if (!this.props.fieldName) {
          this.props.selectionHandler(event.detail.item.value !== '' ? event.detail.item.value : undefined);
          return;
        }
        else {
          const selection = {};
          selection[this.props.fieldName] = event.detail.item.value !== '' ? event.detail.item.value : undefined;
          this.props.selectionHandler(selection);
        }
        return;
    }

    render() {
      log.debug('render(): ', this.props);

      const {min, max} = parseMinMaxIntsAndOrder(this.props.min, this.props.max);
      const value = parseInt(this.props.value);
      const asDropDown = this.props.asDropDown && !isNaN(min) && !isNaN(max);

      if (!asDropDown) {
        return (
          <input
            type="number"
            value={value}
            min={min}
            max={max}
            placeholder={(this.props.prompt && LANGUAGES_CONTROLLER.format(this.props.languages, this.props.prompt)) || ''}
            onChange={this.selectionHandler.bind(this)}
          />
        )

      }
      let optionsList = [];
      
      // Add prompt option if provided
      if (this.props.prompt !== '') {
        optionsList.push({
          key: '',
          value: '',
          label: LANGUAGES_CONTROLLER.format(this.props.languages, this.props.prompt),
          selected: !value || isNaN(value)
        });
      }
      
      // Add numeric options
      if (this.props.descendingOrder) {
        for (let i = max; i >= min; i--) {
          optionsList.push({
            key: i,
            value: i,
            label: i.toString(),
            selected: value === i
          });
        }
      }
      else {
        for (let i = min; i <= max; i++) {
          optionsList.push({
            key: i,
            value: i,
            label: i.toString(),
            selected: value === i
          });
        }
      }

      return (
        <SSelect
          inputId={`integer-selector-${this.props.fieldName || 'default'}`}
          optionsList={optionsList}
          multiple={false}
          onS-select={this.selectionHandler.bind(this)}
        />
      )
    }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}



IntegerSelector.defaultProps = {
  asDropDown: false,
  noSelectionAllowed: true,
  descendingOrder: false,
};

// Wrap the component to inject state into it
export default connect(mapStateToProps)(IntegerSelector);